var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg418020461225001733135856(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15C16.5 13.895 13.366 13 9.5 13M16.5 15C16.5 16.105 13.366 17 9.5 17C5.634 17 2.5 16.105 2.5 15M16.5 15V19.937C16.5 21.076 13.366 22 9.5 22C5.634 22 2.5 21.077 2.5 19.937V15M16.5 15C20.324 15 23.5 14.013 23.5 13V3M9.5 13C5.634 13 2.5 13.895 2.5 15M9.5 13C5.082 13 1.5 12.013 1.5 11V6M9.5 4C5.082 4 1.5 4.895 1.5 6M1.5 6C1.5 7.105 5.082 8 9.5 8C9.5 9.013 12.753 10 16.577 10C20.401 10 23.5 9.013 23.5 8M23.5 3C23.5 1.895 20.4 1 16.577 1C12.754 1 9.654 1.895 9.654 3M23.5 3C23.5 4.105 20.4 5 16.577 5C12.754 5 9.654 4.105 9.654 3M9.654 3V13.166",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg418020461225001733135856);
export default __webpack_public_path__ + "static/media/418020461225001733135856.66e937d763f8b105e1b5a6f823f283ec.svg";
export { ForwardRef as ReactComponent };